export const GET_ATTENDANCE_REMARKS = 'GET_ATTENDANCE_REMARKS'
export const ATTENDANCE_REMARKS_ADD = 'ATTENDANCE_REMARKS_ADD'
export const GET_BY_TYPE = 'GET_BY_TYPE'
export const DELETE_ATTENDANCE_REMARKS = 'DELETE_ATTENDANCE_REMARKS'
